const data = {};

data.template = `<div class="A4 water-mark water-mark-ie" style="padding-bottom: 20px;font-family: Cordia New;font-size: 26px;">
<div style="font-family: 'Cordia New';font-size: 26px;">
<div contenteditable="false" style="text-align: center;"><span contenteditable="false" class="date">{date}</span>
</div>
<div>&nbsp;</div>
<div style="line-height: 1.5;"><span contenteditable="true">เรื่อง&nbsp;&nbsp;&nbsp;&nbsp;</span><span
        contenteditable="true">แจ้งสงวนสิทธิ์การเรียกค่าปรับ</span></div>
<div style="line-height: 1.5;"><span contenteditable="true">เรียน&nbsp;&nbsp;&nbsp;</span><span contenteditable="false"
        class="company_name">{company_name}</span></div>
<div style="line-height: 1.5;"><span contenteditable="true">อ้างถึง&nbsp;</span><span contenteditable="false"
        class="reference">สัญญาเลขที่&nbsp;</span><span contenteditable="false"
        class="po_contract_no">{po_contract_no}</span><span contenteditable="false">&nbsp;ลงวันที่&nbsp;</span><span
        contenteditable="false" class="str_purchase_date_th">{str_purchase_date_th}</span></div>
<div style="height: 420px;">
    <div>&nbsp;</div>
    <div style="line-height: 1.5;">
        <span style="padding-left: 80px;" contenteditable="true">ตามสัญญาที่อ้างถึง บริษัท ปตท.จํากัด (มหาชน) ได้</span> <span
        contenteditable="false" class="po_header_text">{po_header_text}</span> <span
        contenteditable="true">แล้วนั้น</span>
    </div>
    <div style="line-height: 1.5;">&nbsp;</div>
    <div style="line-height: 1.5;">
        <span style="padding-left: 80px;" contenteditable="true">เนื่องจาก</span> <span contenteditable="false"
            class="company_name">{company_name}</span> <span contenteditable="false" class="reason">{reason}</span>
        <span contenteditable="true">จึงขอแจ้งสงวนสิทธิ์เรียกค่าปรับตามสัญญาหรือข้อตกลง </span>
    </div>
    <div>&nbsp;</div>
    <div style="line-height: 1.5;"><span style="padding-left: 80px;" contenteditable="false">จึงเรียนมาเพื่อโปรดทราบ</span></div>
</div>
<div>
    <p style="text-align: center;" contenteditable="true">ขอแสดงความนับถือ</p>
    <p style="text-align: center;" contenteditable="false">&nbsp;</p>
    <p style="text-align: center;" contenteditable="false">&nbsp;</p>
    <p style="text-align: center;" contenteditable="false" class="approver_name">{approver_name}</p>
    <p style="text-align: center;" contenteditable="true" >{#approver_position}</p>
    <p style="text-align: center;" contenteditable="true">Electronically approved by Acceptance Committee</p>
</div>
<div>
    <div>&nbsp;</div>
    <div style="line-height: 1.5;text-align: left;" contenteditable="false" class="org_unit">{org_unit}</div>
    <div style="line-height: 1.5;text-align: left;" contenteditable="false"><span>โทร. </span><span
            class="org_unit_tel">{org_unit_tel}</span></div>
</div>
</div>
</div>`;

export default data;